export default __webpack_public_path__ + "static/media/46_2_1.03c13490.png";